import { createAsyncActionTypes } from 'conversations-async-data/async-action/createAsyncActionTypes';
export const SEND_HEARTBEAT = 'SEND_HEARTBEAT';
export const SEND_OFFLINE_NOTICE = createAsyncActionTypes('SEND_OFFLINE_NOTICE');